module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-join"
  }, [(!_vm.successMessage) ? _c('form', {
    ref: "form",
    staticClass: "b-join__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "b-join__label"
  }, [_vm._v("Get updates")]), _c('div', {
    staticClass: "visible-xs-block clearfix"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "b-join__input form-control",
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "name": "FNAME"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "visible-xs-block clearfix"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "b-join__input -email form-control",
    class: {
      '-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": "Email address",
      "name": "EMAIL",
      "data-vv-name": "email",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "visible-xs-block clearfix"
  }), _c('button', {
    staticClass: "b-join__btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Join")])]) : _vm._e(), (!_vm.errorMessage && !_vm.successMessage && _vm.errors.has('email')) ? _c('div', {
    staticClass: "b-join__message -error",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e(), (_vm.errorMessage && !_vm.successMessage) ? _c('div', {
    staticClass: "b-join__message -error",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), (_vm.successMessage) ? _c('div', {
    staticClass: "b-join__message -success",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v(_vm._s(_vm.successMessage))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4373d92b","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Mailchimp.vue
// module id = 42
// module chunks = 0